// Redux
import { Dispatch } from "redux";

// Classes
import { GenderReducerState } from "../classes/gender.classes";

// Action Creators
import {
  setFemale,
  setMale,
  setOtherThirdGender,
  setGenderState
} from "../actionCreators/gender.actionCreators";
  
export const setGenderValue = (
  dispatch: Dispatch<any>,
  value: boolean,
  identifier: "female" | "male" | "otherThirdGender"
) => {
  switch (identifier) {
    case "female":
      dispatch(setFemale(!value));
      break;
    case "male":
      dispatch(setMale(!value));
      break;
    case "otherThirdGender":
      dispatch(setOtherThirdGender(!value));
      break;
  }
};

export const initializeGenderState = (
  dispatch: Dispatch<any>,
  state: GenderReducerState
) => {
  dispatch(setGenderState(state));
};
